// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import Icon from 'components/common/Icon'
import TetherPortal from 'components/common/TetherPortal'

import styles from './Dropdown.module.scss'

export const DropdownContext = React.createContext()

export const ChevronAnchor = React.forwardRef(
  ({ className = undefined, isActive, ...props }, ref) => (
    <span
      className={cx(styles.anchor, {
        [styles.active]: isActive,
        [className]: Boolean(className),
      })}
      ref={ref}
      {...props}
    >
      <Icon className={styles.chevron} name="chevronDown" />
    </span>
  ),
)

export const Dropdown = ({
  Anchor = ChevronAnchor,
  children,
  className = undefined,
  focus,
  order = 'bottom top right left center',
}) => {
  const ref = React.useRef()

  const [isOpen, setOpen] = React.useState(focus)

  const toggle = React.useCallback(() => setOpen(R.not), [])
  const dismiss = React.useCallback(() => setOpen(false), [])

  return (
    <DropdownContext.Provider value={dismiss}>
      <Anchor
        className={className}
        ref={ref}
        onClick={toggle}
        isActive={isOpen}
      />
      <TetherPortal
        anchorRef={ref}
        order={order}
        dismiss={dismiss}
        open={isOpen}
      >
        <div className={styles.content}>{children}</div>
      </TetherPortal>
    </DropdownContext.Provider>
  )
}
